module.exports = __webpack_public_path__ + "static/media/CTLI_16-235w.701ba828.jpg";